module.exports = __webpack_public_path__ + "src/assets/individualImages/melliferaFedora.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/melliferaFedora.png
// module id = ./src/assets/individualImages/melliferaFedora.png
// module chunks = 0